import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

const createNotificationFn = (notificationType, title, content, duration) => {
  return () => {
    NotificationService.showNotification({
      notificationType,
      title,
      content,
      duration,
    });
  };
};

export const getErrorNotification = (title, content) => {
  return createNotificationFn(NOTIFICATION_TYPE_ERROR, <FormattedMessage {...title} />, <FormattedMessage {...content} />, 3000);
};
